<template>
    <div class="input-group-sm">
        <select :title="item.desc" @change="changeselect($event)" class="form-control">
				<option v-for="(sitem,index) in item.value" :value="index">{{sitem.desc}}</option>
			</select>
        <template v-for="sitem in item.value">
            <my-component-number v-if="sitem.type=='number' && sitem.hidden!=true" :item="sitem"></my-component-number>
        </template>
    </div>
</template>

<script>
    export default {
        props: ['item'],
        methods: {
            changeselect: function (event) {
                console.log(event.target.value)
                var plan = event.target.value;
                for (var v in this.item.value) {
                    this.item.value[v].hidden = true;
                }
                this.item.value[plan].hidden = false;
                this.item.selected = plan;
            }
        }
    }

</script>

<style>

</style>


// WEBPACK FOOTER //
// select.vue?d2443a7a